import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import LightBox from '@bd/bdui-lightbox';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import { FavoriteToggle } from './Favorites';
import CompareButton from './CompareButton';
import ScheduleModal from '../components/ScheduleModal';
import { colors } from '../styles';

const styles = css`
  width: calc(100vw - 60px);
  max-width: 375px;
  margin: 0 20px 40px 20px;
  .CommunityCard_wrapper {
    display: flex;
    @media (min-width: 992px) {
      &:hover {
        .CommunityCard_media {
          box-shadow: 0 10px 15px 0 rgba(0,0,0,0.15);
        }
      }
    }
    a {
      color: ${colors.body};
    }
  }
  .CommunityCard_inner {
    width: 100%;
  }
  .CommunityCard_media {
    position: relative;
    transition: all .3s ease;
    border: 10px solid ${colors.white};
    overflow: hidden;
    a {
      display: block;
    }
  }
  .CommunityCard_image {
    width: 100%;
    height: auto;
  }
  .CommunityCard_content {
    padding: 10px 0 0 0;
    position: relative;
  }
  .CommunityCard_communityName {
    font-size: 17px;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 3px 0;
    color: ${colors.body};
    vertical-align: top;
    display: block;
    padding: 0 15px 0 0;
    @media (min-width: 480px) {
      font-size: 18px;
    }
  }
  .CommunityCard_status {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    border-left: 1px solid ${colors.gray};
    margin: 0 0 0 10px;
    padding: 0 0 0 10px;
    display: inline-block;
    vertical-align: middle;
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .CommunityCard_address {
    margin: 0 0 0 0;
    font-size: 15px;
    line-height: 1;
    font-weight: 400;
    color: ${colors.body};
    a {
      color: ${colors.body};
    }
  }
  .CommunityCard_city {
    margin: 0 0 0 0;
    font-size: 15px;
    font-weight: 400;
    color: ${colors.body};
    a {
      color: ${colors.body};
    }
  }
  .CommunityCard_priceLabel {
    margin: 0 0 0 0;
    font-size: 15px;
    line-height: 1;
    font-weight: 400;
    color: ${colors.body};
    a {
      color: ${colors.body};
    }
  }
  .CommunityCard_priceValue {
    font-size: 17px;
    font-weight: 700;
    line-height: 1;
    margin: 0;
    color: ${colors.body};
    vertical-align: middle;
    @media (min-width: 480px) {
      font-size: 18px;
    }
  }
  .CommunityCard_iconList {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 8px 0 0 0;
    width: 75%;
    flex-wrap: wrap;
    @media (min-width: 1200px) {
      width: 70%;
    }
  }
  .CommunityCard_iconListItem {
    text-align: left;
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    margin: 0 8px 5px 0;
    &:first-child {
      padding: 0 8px 0 0;
      border-right: 1px solid ${colors.gray};
    }
  }
  .CommunityCard_iconListIcon {
    margin: 0 0 4px 0;
    display: none;
  }
  .CommunityCard_iconListValue {
    font-weight: 700;
    margin: 0 3px 0 0;
  }
  .CommunityCard_linkIcon {
    width: 13px;
    height: 13px;
    margin: 5px 0 0 0;
    display: none;
  }
  .CommunityCard_mapButtonWrapper {
    width: 23px;
    height: 31px;
    position: absolute;
    top: 15px;
    right: 15px;
    display: none;
  }
  .CommunityCard_mapButton {
    width: 23px;
    height: 31px;
    background-image: url('/images/icon-map-pin-brand2.svg');
    background-position: center center;
    background-repeat: no-repeat;
  }
  .CommunityCard_detailButton {
    height: 45px;
    width: 45px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    transition: all .3s ease;
    overflow: visible;
    transform-origin: bottom right;
    transform: rotate(-45deg);
    &::before {
      content: '';
      position: absolute;
      top: 19px;
      left: 38px;
      width: 16px;
      height: 16px;
      background-image: url('/images/icon-plus.svg');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      transition: all .3s ease;
      z-index: 2;
      opacity: 1;
      transform: rotate(-45deg);
    }
    &::after {
      content: '';
      height: 90px;
      width: 90px;
      background-color: ${colors.white};
      background-image: none;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      transition: all .3s ease;
      z-index: 1;
    }
    &:focus {
      outline: none;
    }
    &:hover {
      height: 110px;
      width: 110px;
      transform: rotate(0deg);
      &::before {
        transform: rotate(45deg);
        top: 90px;
        left: 90px;
        opacity: 0;
        transform: rotate(0deg);
      }
      &::after {
        top: 55px;
        left: 55px;
        width: 120px;
        height: 120px;
      }
      .CommunityCard_detailButtonIcon1 {
        top: 8px;
        left: 65px;
        opacity: 1;
      }
      .CommunityCard_detailButtonIcon2 {
        top: 30px;
        left: 28px;
        opacity: 1;
      }
      .CommunityCard_detailButtonIcon3 {
        top: 67px;
        left: 8px;
        opacity: 1;
      }
      .CommunityCard_detailButton-disabled {
        pointer-events: none;
        opacity: .8 !important;
        filter: saturate(0);
      }
    }
  }
  .CommunityCard_detailButtonIcon1 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-chat-blue.svg');
    background-position: center center;
    background-size: 26px 22px;
    background-repeat: no-repeat;
  }
  .CommunityCard_detailButtonIcon2 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-360-blue-circle.svg');
    background-position: center center;
    background-size: 30px 30px;
    background-repeat: no-repeat;
  }
  .CommunityCard_detailButtonIcon3 {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    top: -40px;
    left: -40px;
    background-color: ${colors.white};
    transition: all .3s ease;
    opacity: 0;
    background-image: url('/images/icon-camera-blue-circle.svg');
    background-position: center center;
    background-size: 30px 30px;
    background-repeat: no-repeat;
  }
  .CommunityCard_list1 {
    list-style: none;
    margin: 0 -20px;
    border-top: 1px solid ${colors.neutral};
    border-bottom: 1px solid ${colors.neutral};
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .CommunityCard_list2 {
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  }
  .CommunityCard_list2Item {
    font-size: 14px;
    line-height: 1.2;
    flex: 1;
    padding: 12px 0 0 0;
    a {
      font-weight: 700;
    }
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .CommunityCard_openHouseBanner {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: ${colors.white};
      opacity: .8;
    }
  }
  .CommunityCard_openHouseBannerContent {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
    position: relative;
    z-index: 2;
  }
  .CommunityCard_headlineBanner {
    position: relative;
    background-color: ${colors.white};
    padding: 5px 10px 10px;
    font-size: 14px;
    line-height: 1;
    font-weight: 700;
    position: relative;
    color: ${colors.brand1};
  }
  .sold {
    color: ${colors.brand3};
    text-transform:uppercase;
  }
`;

const videoBoxStyle = css`
  position: relative;
  width: 80vw;
  height: 80vh;
  margin: 10vh 10vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;


function CommunityCard({ community }) {
  return (
    <div className={styles}>
      <ActivateMapPin hover itemId={get(community, '_id')}>
        <div className="CommunityCard_wrapper">
          <div className="CommunityCard_inner">
            <div className="CommunityCard_media">
              <Link name="community-detail" community={community}>
                <Image
                  className="CommunityCard_image"
                  src={get(community, 'photos[0].contentUrl')}
                  alt={get(community, 'photos[0].name', get(community, 'photos[0].caption', ''))}
                  width={600}
                  height={400}
                  applySize
                  exact
                />
              </Link>
              <div className="CommunityCard_detailButton" role="button" tabIndex="0" onClick="">
                {
                  community &&
                  get(community, 'schedule_appointment_link') &&
                  <ScheduleModal community={community}>
                    <div className="CommunityCard_detailButtonIcon1" title="Schedule Appointment" />
                  </ScheduleModal>
                }
                {
                  community &&
                  !get(community, 'schedule_appointment_link') &&
                  <Link name="schedule-appointment">
                    <div className="CommunityCard_detailButtonIcon1" title="Schedule Appointment" />
                  </Link>
                }
                <LightBox
                  items={[{
                    element: (
                      <div className={videoBoxStyle}>
                        <div className="col-lg-8 embed-responsive embed-responsive-16by9 mx-auto">
                          <iframe title="Tour" src={get(community, 'toururl')} frameBorder="0" allowFullScreen />
                        </div>
                      </div>
                    ) }]
                  }
                  enableZoom
                >
                  <div className={`CommunityCard_detailButtonIcon2 ${!get(community, 'toururl') ? 'CommunityCard_detailButton-disabled' : ''}`} title="Virtual Tour" />
                </LightBox>
                <LightBox items={get(community, 'photos')} enableZoom>
                  <div className="CommunityCard_detailButtonIcon3" title="Photo Gallery" />
                </LightBox>
              </div>
              <FavoriteToggle home={community} />
            </div>
            {
              get(community, 'headline') &&
              <div className="CommunityCard_headlineBanner">
                {get(community, 'headline')}
              </div>
            }
            <div className="CommunityCard_content">
              <div className="d-flex justify-content-between">
                <div>
                  {
                    get(community, 'name') &&
                    <Link name="community-detail" community={community}>
                      <span className="CommunityCard_communityName">{get(community, 'name')}</span>
                    </Link>
                  }
                  <h4 className="CommunityCard_address">
                    <Link name="community-detail" community={community}>
                      <span className="CommunityCard_city">{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</span>
                    </Link>
                  </h4>
                </div>
                <div>
                  <Link name="community-detail" community={community}>
                    <div className="CommunityCard_priceLabel">From</div>
                    <div className="CommunityCard_priceValue">{numeral(get(community, 'priceLow')).format('$0,0')}</div>
                  </Link>
                </div>
              </div>
              <a href={GoogleMapUrl(community)} className="CommunityCard_mapButtonWrapper" target="_blank" rel="noopener noreferrer" title={community.name}>
                <div className="CommunityCard_mapButton" title="Map This Home" />
              </a>
              <ul className="CommunityCard_iconList">
                {
                  get(community, 'bedsLow') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListValue">
                      {get(community, 'bedsLow')}
                      {
                        get(community, 'bedsHigh') &&
                        ` - ${get(community, 'bedsHigh')}`
                      }
                    </span>
                    <span className="CommunityCard_iconListLabel"> Beds</span>
                  </li>
                }
                {
                  get(community, 'custom_bath_range') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListValue">
                      {get(community, 'custom_bath_range')}
                    </span>
                    <span className="CommunityCard_iconListLabel"> Baths</span>
                  </li>
                }
                {
                  get(community, 'sqftLow') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListValue">
                      {numeral(get(community, 'sqftLow')).format('0,0')}
                      {
                        get(community, 'sqftHigh') &&
                        <span> - {numeral(get(community, 'sqftHigh')).format('0,0')}</span>
                      }
                    </span>
                    <span className="CommunityCard_iconListLabel"> SQ FT</span>
                  </li>
                }
              </ul>
              <CompareButton
                limit={5}
                className="CommunityListCard_btnCompare"
                type="homes"
                id={community._id}
              />
            </div>
          </div>
        </div>
      </ActivateMapPin>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object,
};

CommunityCard.defaultProps = {
  community: undefined,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(CommunityCard);



// WEBPACK FOOTER //
// ./src/components/CommunityCardVertical.js